/*
  Leina Label: quick add bottom sheet for touch devices.

  This file only opens and closes the sheet. Choosing a size and enabling the button is handled by
  assets/leina-hover-quick-add.js, and adding to cart by the theme's assets/product-form.js, so the
  desktop behaviour is untouched.

  While open, the panel is moved to the end of <body> and put back on close. A fixed element breaks
  if any ancestor has a transform, and cards can pick one up from theme CSS; moving it rules that out.
  The form's listeners were bound when the page loaded and travel with the element, so nothing is
  bound twice.
*/
(function () {
  if (window.leinaQuickAddMobile) return;
  window.leinaQuickAddMobile = true;

  var MOBILE_QUERY = '(max-width: 989px), (hover: none)';
  var open = null; // { panel, trigger, placeholder }
  var scrim = null;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function getScrim() {
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'leina-qa-scrim';
      scrim.addEventListener('click', closeSheet);
    }
    return scrim;
  }

  function openSheet(trigger) {
    var card = trigger.closest('.card__inner') || trigger.parentNode;
    var panel = card ? card.querySelector('[data-leina-qa]') : null;
    if (!panel) return;

    closeSheet();

    // Remember where the panel lives so it can go back exactly there
    var placeholder = document.createComment('leina-qa');
    panel.parentNode.insertBefore(placeholder, panel);

    var el = getScrim();
    document.body.appendChild(el);
    document.body.appendChild(panel);
    panel.classList.add('leina-qa--sheet');
    document.documentElement.classList.add('leina-qa-sheet-open');
    trigger.classList.add('is-active');
    trigger.setAttribute('aria-expanded', 'true');

    open = { panel: panel, trigger: trigger, placeholder: placeholder };

    // Next frame so the slide-up and fade-in animate from their starting values
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add('is-open');
        panel.classList.add('is-open');
      });
    });
  }

  function closeSheet() {
    if (!open) return;

    var panel = open.panel;
    var trigger = open.trigger;
    var placeholder = open.placeholder;
    open = null;

    panel.classList.remove('is-open', 'leina-qa--sheet');
    if (scrim) scrim.classList.remove('is-open');
    document.documentElement.classList.remove('leina-qa-sheet-open');

    if (trigger) {
      trigger.classList.remove('is-active');
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (placeholder && placeholder.parentNode) {
      placeholder.parentNode.insertBefore(panel, placeholder);
      placeholder.parentNode.removeChild(placeholder);
    } else if (panel.parentNode) {
      // Its card is gone (a filter or sort redrew the grid), so the panel goes with it
      panel.parentNode.removeChild(panel);
    }

    if (scrim && scrim.parentNode) scrim.parentNode.removeChild(scrim);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest ? event.target.closest('[data-leina-qa-open]') : null;
    if (trigger) {
      if (!isMobile()) return;
      event.preventDefault();
      event.stopPropagation();
      openSheet(trigger);
      return;
    }

    // A tap anywhere outside the sheet closes it
    if (open && !event.target.closest('[data-leina-qa]')) {
      closeSheet();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && open) closeSheet();
  });

  // Close once the item is in the cart, so the theme's cart drawer is what the shopper sees
  if (typeof subscribe === 'function') {
    subscribe('cart-update', function () {
      closeSheet();
    });
  }

  // Leaving mobile widths, or a filter/sort replacing the grid, must not strand the panel
  window.matchMedia(MOBILE_QUERY).addEventListener('change', closeSheet);
  document.addEventListener('shopify:section:load', closeSheet);
  window.addEventListener('pageshow', closeSheet);
})();
